'use client';
import Modal from '@/components/molecules/modal';
import React, { createContext, useContext, useMemo, useState } from 'react';
import { signOut as signOutNextAuth } from 'next-auth/react';
import noAccess from '@/assets/images/no-access.png';
import Image from 'next/image';
interface IDataType {
  handleOpenUnauthorized: (url?: string) => void;
}

const UnauthorizedContext = createContext<IDataType>({} as IDataType);

export const UnauthorizedProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [openUnauthorized, setOpenUnauthorized] = useState(false);
  const [callbackUrl, setCallbackUrl] = useState<string | undefined>(undefined);

  async function handleReSingnIn() {
    await signOutNextAuth({
      redirect: true,
      callbackUrl: '/auth?callbackUrl=' + callbackUrl,
    });
  }

  function handleContinue() {
    setOpenUnauthorized(false);
  }

  function handleOpenUnauthorized(url?: string) {
    setOpenUnauthorized(true);
    if (!url) {
      url = window.location.pathname;
    }
    setCallbackUrl(url);
  }

  const contextValue = useMemo(() => ({ handleOpenUnauthorized }), []);
  return (
    <UnauthorizedContext.Provider value={contextValue}>
      {children}
      <Modal
        open={openUnauthorized}
        textSubmit="Đăng nhập lại"
        textCancel="Hủy"
        maskClosable={false}
        onCancel={handleContinue}
        onOk={handleReSingnIn}
        titleWithTemplate
        closable={false}
        template={
          <h2 style={{ textAlign: 'center', color: '#f00' }}>
            Phiên đăng nhập của bạn đã hết hạn
          </h2>
        }
      >
        <div
          className="modal-unauthorized"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <p>Vui lòng đăng nhập lại để tiếp tục sử dụng dịch vụ.</p>
          <Image
            src={noAccess}
            alt="no-access"
            width={200}
            height={200}
            style={{
              objectFit: 'cover',
            }}
          />
        </div>
      </Modal>
    </UnauthorizedContext.Provider>
  );
};

export function useUnauthorized() {
  const context = useContext(UnauthorizedContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
}

export default UnauthorizedProvider;
